<template>
  <g>
    <path
      d="M6.18 20.0001C7.38398 20.0001 8.36 19.0241 8.36 17.8201C8.36 16.6162 7.38398 15.6401 6.18 15.6401C4.97602 15.6401 4 16.6162 4 17.8201C4 19.0241 4.97602 20.0001 6.18 20.0001Z"
    />
    <path
      d="M5.59 10.2303C4.75 10.0903 4 10.7803 4 11.6303C4 12.3403 4.53 12.9103 5.23 13.0303C8.15 13.5403 10.45 15.8503 10.97 18.7703C11.09 19.4703 11.66 20.0003 12.37 20.0003C13.22 20.0003 13.91 19.2503 13.78 18.4103C13.1 14.2103 9.79 10.9003 5.59 10.2303ZM5.56 4.52033C4.73 4.43033 4 5.10033 4 5.93033C4 6.66033 4.55 7.26033 5.27 7.33033C11.28 7.93033 16.06 12.7103 16.66 18.7203C16.73 19.4503 17.33 20.0003 18.06 20.0003C18.9 20.0003 19.56 19.2703 19.48 18.4403C18.75 11.1003 12.91 5.25033 5.56 4.52033Z"
    />
  </g>
</template>
